export const WIDTH_TO_HEIGHT_RATIO_THRESHOLD_TO_CROP_SUPER_WIDE = 2;
export const WIDTH_TO_HEIGHT_RATIO_THRESHOLD_TO_CROP_SUPER_TALL = 0.5625;
export const WIDTH_TO_HEIGHT_RATIO_DEFAULT_LANDSCAPE = 1.78; // 16 (width) / 9 (height)
export const WIDTH_TO_HEIGHT_RATIO_DEFAULT_PORTRAIT = 0.5625; // 9 (width) / 16 (height)
export const TINY_IMAGE_WIDTH_THRESHOLD = 50;
export const TINY_IMAGE_HEIGHT_THRESHOLD = 50;
export const TINY_IMAGE_SIZE_MULTIPLIER = 2;
export const CHARS_BEFORE_LONG_STATUS = 110;
